"use client";

import { DismissableLayer as DismissableLayerPrimitive } from "radix-ui/internal";
import type { ReactNode } from "react";

export function DialogDismissalLayer({ open, onOpenChange, children }: { open: boolean; onOpenChange: (open: boolean) => void; children?: ReactNode }) {
  if (!open) return null;
  return (
    <DismissableLayerPrimitive.DismissableLayer
      className="contents"
      onDismiss={() => onOpenChange(false)}
      onInteractOutside={(event) => event.preventDefault()}
    >
      {children}
    </DismissableLayerPrimitive.DismissableLayer>
  );
}
